<template>
	<SOSlotModal
		:modal-title="'Ubah Jenis Kelamin'"
		:modal-id="id"
		@close="close"
	>
		<template v-slot:modal-body>
			<label class="form-label require">
				Jenis Kelamin
			</label>
			<SOInputRadioBig
				:radio-group="jenisKelamin"
				:radio-selected="customer.jenis_kelamin"
				@selected-radio="(val) => { customerTemp.jenis_kelamin =  val }"
			/>
			<ErrorMessage
				class="error"
				label="Jenis Kelamin"
				:validation="$v.customerTemp.jenis_kelamin"
			/>
		</template>
		<template v-slot:modal-footer>
			<SOButton
				:text="'Simpan'"
				:primary="true"
				:full="true"
				:disable="pageSetting.btn.save.disabled"
				:loading="pageSetting.btn.save.loading"
				@action="update"
			/>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapGetters} from "vuex";
import {required} from "vuelidate/lib/validators";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputRadioBig from "@/so-components/global/input/SOInputRadioBig";
import SOButton from "@/so-components/global/ui/SOButton";
import ErrorMessage from "@/component-items/ErrorMessage";

export default {
	name: "CustomerModalUbahJenisKelamin",
	components: {
		SOSlotModal,
		SOInputRadioBig,
		SOButton,
		ErrorMessage
	},
	computed: {
		...mapGetters("customerModule", {
			customer: "getDetailCustomer",
		}),
		...mapGetters("metaModule", {
			jenisKelamin: "getJenisKelamin",
		})
	},
	data() {
		return {
			id: "modal-customer",
			customerTemp: {},
			pageSetting: {
				btn: {
					save: {
						disabled: false,
						loading: false,
					}
				}
			}
		}
	},
	validations: {
		customerTemp: {
			jenis_kelamin: {
				required
			}
		},
	},
	mounted() {
		$("#" + this.id).modal("show");
		this.cloneVar()
	},
	watch: {
		customerTemp: {
			handler: function () {
				this.validate()
			},
			deep: true,
		}
	},
	methods: {
		cloneVar() {
			this.customerTemp = JSON.parse(JSON.stringify(this.customer))
		},
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		validate() {
			this.pageSetting.btn.save.disabled = this.errorValidation()
		},
		errorValidation() {
			this.$v.customerTemp.jenis_kelamin.$touch()
			return this.$v.customerTemp.jenis_kelamin.$invalid
		},
		async update() {
			this.pageSetting.btn.save.disabled = true;
			this.pageSetting.btn.save.loading = true
			const res = await this.$store.dispatch("customerModule/updateCustomerJenisKelamin", this.customerTemp)
			this.pageSetting.btn.save.disabled = false;
			this.pageSetting.btn.save.loading = false;
			if (res.success) {
				this.$toast.success(res.msg)
				this.close()
			} else {
				this.$toast.error(res.err)
			}
		},
	}
}
</script>